import request from './request';
const GET_PACKAGE_CLAIM_RECORDS = 'amp2.MrmsSrv/GetGiftRecord';

export default class ClaimRecord {
  static async getClaimRecords(params) {
    return request.post(GET_PACKAGE_CLAIM_RECORDS, params);
  }
}
